import {
    ActionPerformed,
    PushNotificationSchema,
    PushNotifications,
    Token,
} from '@capacitor/push-notifications';
import { Injectable, NgZone } from '@angular/core';
import { CwtAuthStoreService } from '@cawita/core-front/auth';
import { CwtApiService } from '@cawita/core-front/api';
import { filter, take, takeWhile } from 'rxjs/operators';
import { isset } from '@cawita/core-front';
import { App } from '@capacitor/app';
import { Device } from '@capacitor/device';
import { Notification } from '../../../../../frontend-shared/src/lib/models';
import { NotificationHandlerService } from './notification-handler.service';

@Injectable({ providedIn: 'root' })
export class PushNotificationService {
    private _fcmToken: string;

    constructor(
        private auth: CwtAuthStoreService,
        private api: CwtApiService,
        private zone: NgZone,
        private handler: NotificationHandlerService
    ) { }

    public async init() {
        const device = await Device.getInfo();
        if (device.platform === 'web') return;

        const permissionResults = await PushNotifications.requestPermissions();
        if (permissionResults.receive !== 'granted') return;

        PushNotifications.addListener('registration', this._onRegister);
        PushNotifications.addListener('pushNotificationActionPerformed', this._onAction);

        PushNotifications.register();
    }

    private _onRegister = (token: Token) => {
        this._fcmToken = token.value;
        this.zone.run(() => this._registerToken());
    }

    private _onAction = (action: ActionPerformed) => {
        try {
            const content = JSON.parse(action.notification.data.content);
            const notification = new Notification({
                ...action.notification.data,
                content: content
            });
            this.zone.run(() => this.handler.handle(notification));
        } catch (err) {
            //
        }
    }

    private async _registerToken() {
        await this.auth.state$.pipe(filter(s => isset(s.user)), take(1)).toPromise();
        await this.api.post('user/logged/token', { token: this._fcmToken }, { customErrorHandler: true }).toPromise();
    }

}